module.exports = __webpack_public_path__ + "static/media/minusIcon.fa00f4b2.svg";